import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function ltlSurChargeValidator(rateTypeId:any,frtLtlMin:any,masterLtlMax:any):ValidatorFn {
    return (control: AbstractControl): {[key: string]: boolean} | null => {
        if (rateTypeId === 18){
            return null;
        }
        if(control.value !== null){
            let ltlSurcharge = control.value;
            if(masterLtlMax > 0
               && +ltlSurcharge > +masterLtlMax){
                return{ ltlSur1 : true};
            }
            if((+ltlSurcharge <= 0) &&(+frtLtlMin >=0)){
                return { ltlSur2 : true};
            }
        }
        return null;
    }

}

export function ltlMinChargeValidator(rateTypeId:any, masterLtlMin:any):ValidatorFn {
    return (control: AbstractControl): {[key: string]: boolean} | null => {
        if (rateTypeId === 18){
            return null;
        }
        if(control.value !== null){
            let ltlMincharge = control.value;

            if(masterLtlMin > 0 && +ltlMincharge > +masterLtlMin){
                return{ ltlMin1 : true};
            }
        }
        return null;
    }

}

export function tlRateAmountValidator(rateTypeId:any, frtTlMin:any,masterTlMax:any):ValidatorFn{
    return (control: AbstractControl): {[key: string]: boolean} | null => {
    if (rateTypeId === 19){
            return null;
    }
    if(control.value !== null){
        let tlRateAmount = control.value;
        if(masterTlMax > 0 && +tlRateAmount > +masterTlMax){
            return{ tlSur1 : true};
        }
        if((+tlRateAmount <= 0) &&(+frtTlMin >=0)){
            return { tlSur2 : true};
        }
    }
    return null;
    }
}

export function tlMinChargeValidator(rateTypeId:any, masterTlMin:any):ValidatorFn {
    return (control: AbstractControl): {[key: string]: boolean} | null => {
        if (rateTypeId === 19){
            return null;
        }
        if(control.value !== null){
            let tlMincharge = control.value;
            if(masterTlMin > 0 && +tlMincharge > +masterTlMin){
                return{ tlMin1 : true};
            }
        }
        return null;
    }

}
export function commaSeparatedEmailsValidator(): ValidatorFn {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  const commaSeparatedEmailsPattern = /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6})(,\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6})*$/;

  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; // don't validate if the value is empty
    }

    const value = control.value;
    if (commaSeparatedEmailsPattern.test(value)) {
      return null; // valid comma-separated emails
    }

    return { invalidEmails: true }; // validation failed
  };
}
